import { DraggableProvided } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { Drag } from 'ui/icons';
import { body1, fontWeights } from 'ui/theme';
import { WhatsAppButtonDefinition } from '../../graphql/types';

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledDragIcon = styled(Drag)`
  transform: rotate(90deg);
  display: flex;
`;

const HeaderTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledTitle = styled.div`
  ${body1}
  font-weight: ${fontWeights.semiBold};
  padding-left: ${({ theme }) => theme.spacing.half};
`;

type Props = {
  data: WhatsAppButtonDefinition;
  draggableProvided: DraggableProvided;
};

export const EditableTitle = ({ data, draggableProvided }: Props) => {
  return (
    <TitleWrapper>
      <div {...draggableProvided.dragHandleProps}>
        <StyledDragIcon />
      </div>
      <HeaderTitleContainer data-test="action-button-name-container">
        <StyledTitle>{data.title || ''}</StyledTitle>
      </HeaderTitleContainer>
    </TitleWrapper>
  );
};
